import type {PS} from '@wix/document-services-types'

export default {
    get(ps: PS): boolean {
        return ps.extensionAPI.accessibility.autoDomReorder.get()
    },
    set(ps: PS, enabled: boolean): void {
        ps.extensionAPI.accessibility.autoDomReorder.set(enabled)
    }
}
